__webpack_public_path__ = `${window.__themeUrl}/dist/`;


// WEBPACK FOOTER //
// ./mtwp/Theme/Js/PublicPath.js